import { render } from "./TransferCardsContainer.vue?vue&type=template&id=ebbf5224"
import script from "./TransferCardsContainer.vue?vue&type=script&lang=js"
export * from "./TransferCardsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__